import { Download } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { clientPlatform } from '@/shared/api/platform'
import { Logo } from '@/shared/components/Logo'
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '@/shared/lib/appStores'
import { useUpdateRequiredStore } from '@/shared/store/updateRequiredStore'

/**
 * «Actualiza la app» (spec `2026-10-17-version-minima-app`): pantalla completa que tapa la app
 * cuando el servidor responde 426 (esta versión ya no está soportada). No se puede cerrar: solo
 * actualizar lo resuelve. Enlaza a la tienda de la plataforma. Overlay a pantalla completa →
 * lleva sus propias safe areas.
 */
export function UpdateRequiredScreen() {
  const { t } = useTranslation()
  const required = useUpdateRequiredStore((s) => s.required)
  const buttonRef = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    if (required) buttonRef.current?.focus()
  }, [required])

  if (!required) return null
  const storeUrl = clientPlatform() === 'android' ? GOOGLE_PLAY_URL : APP_STORE_URL

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="update-required-title"
      aria-describedby="update-required-body"
      className="fixed inset-0 z-[1000] flex flex-col items-center justify-center overscroll-contain bg-background px-6 pb-[calc(1.5rem+env(safe-area-inset-bottom))] pt-[calc(1.5rem+env(safe-area-inset-top))] text-center"
    >
      <Logo className="mb-8 h-10 w-auto" />
      <h1 id="update-required-title" className="font-display text-2xl font-black leading-tight">
        {t('appUpdate.title')}
      </h1>
      <p id="update-required-body" className="mt-3 max-w-sm text-base text-muted-foreground">
        {t('appUpdate.body')}
      </p>
      <a
        ref={buttonRef}
        href={storeUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="brutal-btn brutal-press mt-8 inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-red px-6 py-3 font-display text-base font-bold text-white"
      >
        <Download size={18} strokeWidth={2.5} aria-hidden="true" />
        {t('appUpdate.cta')}
      </a>
    </div>
  )
}
